/** Land ON the section a `#id` in the address names (M23 item 33, review). A page that scrolls once as soon as its first rows are known lands too
 *  high: the browser keeps the scroll position while the panels below render and push the section further down (the workshop's card opened a
 *  machine's page 966 px above its orders). This scrolls on the next frame and again every time the document has grown, until its height has
 *  kept still for `settleMs` or `maxMs` have passed in all. Returns the function that stops it (the effect's cleanup). */
export function scrollToHashWhenSettled(id: string, opts: { settleMs?: number; maxMs?: number; stepMs?: number } = {}): () => void {
  const settleMs = opts.settleMs ?? 400
  const maxMs = opts.maxMs ?? 2500
  const stepMs = opts.stepMs ?? 50
  let stopped = false
  let timer: ReturnType<typeof setTimeout> | undefined
  let frame: number | undefined
  let lastHeight = -1
  let still = 0
  let elapsed = 0
  const tick = () => {
    if (stopped) return
    const el = document.getElementById(id)
    const height = document.documentElement.scrollHeight
    if (el && height !== lastHeight) {
      if (typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'start' })
      lastHeight = height
      still = 0
    } else {
      still += stepMs
    }
    elapsed += stepMs
    if (still < settleMs && elapsed < maxMs) timer = setTimeout(tick, stepMs)
  }
  const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (cb: () => void) => { setTimeout(cb, 0); return undefined }
  frame = raf(tick) as number | undefined
  return () => {
    stopped = true
    clearTimeout(timer)
    if (frame !== undefined && typeof cancelAnimationFrame === 'function') cancelAnimationFrame(frame)
  }
}
